import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AccountService } from './account.service';
import { Injectable } from '@angular/core';

@Injectable()
export class authGuard implements CanActivate {
  constructor(private service: AccountService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // check if the user is already logged

    if (route.data.only_if_not_logged) {
      if (this.service.isAuth) {
        this.router.navigate(['/']);
      }
      return true;
    }
    else {
      if (this.service.isAuth) {
        if (route.data.component) {
          if (this.service.access(route.data.component)) {
            return true;
          }
          else {
            this.router.navigate(['/']);
          }
        }
        return true;
      }
      else {

        if (this.service.checkSession()) {
          if (this.service.access(route.data.component)) {
            return true;
          }
          else {
            this.router.navigate(['/']);
          }
        }
        else {
          this.router.navigate(['/account/login']);
        }
      }

    }

    return true;

  }
}
